export default  {
    BACKEND_URL : process.env.REACT_APP_BACKEND_URL,
    HASURA_URL: process.env.REACT_APP_HASURA_URL,
    RAZORPAY_ID: process.env.REACT_APP_RAZORPAY_ID
}